import React from 'react';
import TriwordLogo from 'url:./assets/TriwordLogo.svg';
import OutcomeBanner from './OutcomeBanner';
import { TriwordStore } from '../_puzzles/Triword/TriwordStore';

const TriwordPreview = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="triwordPreview">
        <div className="puzzleTitle">Triword</div>
        <div className="imageContainer">
          <img className="rubigramIcon" src={TriwordLogo}/>
          <OutcomeBanner store={TriwordStore as any}/>
        </div>
      </div>
    </div>
  );
};

export default TriwordPreview;